<template>
  <div v-if="pollList.length">
    <div class="d-flex my-4">
      <div>
        <h3>Polls</h3>
        <div>
          {{ currentIndex + 1 }}/{{ pollList.length }}
          <span>Questions Done</span>
        </div>
      </div>
      <v-spacer></v-spacer>
      <div v-if="userDetail.profile.is_sebi_registered">
        <v-btn color="primary" class="text-none" @click="openPollDialog"
          >Add Poll</v-btn
        >
      </div>
    </div>
    <!-- <div
      v-if="!userDetail.profile.is_sebi_registered && pollList.length > 0"
      class="d-flex mb-4"
    >
      <div>
        <h3>Polls</h3>
        <div v-if="pollList.length > 0">
          {{ currentIndex + 1 }}/{{ pollList.length }}
          <span>Questions Done</span>
        </div>
      </div>
      <v-spacer></v-spacer>
    </div> -->
    <v-carousel
      hide-delimiters
      height="fit-content"
      class="custom-carousel"
      v-model="currentIndex"
      show-arrows-on-hover
    >
      <v-carousel-item v-for="item in pollList" :key="item.id">
        <v-card>
          <v-card-text>
            <div class="d-flex align-center">
              <v-chip label color="green" class="white--text mr-2">{{
                item.title
              }}</v-chip>
              <div>By {{ item.posted_by.name }}</div>
              <v-icon>mdi-circle-small</v-icon>
              <div class="date-text">{{ item.created }}</div>
            </div>
            <div class="d-flex align-center justify-space-between mt-2">
              <div class="qsn-text">
                {{ item.question }}
              </div>
              <!-- <div>
                <v-btn class="text-none" depressed><v-icon small class="mr-1">mdi-share-variant-outline</v-icon> Share</v-btn>
              </div> -->
            </div>
            <v-divider v-if="!pollList.length" class="my-3"></v-divider>
            <div class="mx-12">
              <v-radio-group
                v-model="item.selected_option"
                v-for="option in item.poll_options"
                :key="option.id"
                @change="postPollAnswer(item, option)"
                class="radios"
              >
                <v-radio
                  :label="option.option_text"
                  :value="option.id"
                ></v-radio>
                <div class="d-flex" v-if="item.voted">
                  <div class="blue--text">{{ option.percentage }}%</div>
                  <v-progress-linear
                    :value="option.percentage"
                    class="mt-1 ml-3"
                    height="9"
                    rounded
                    hide-detail
                  ></v-progress-linear>
                </div>
              </v-radio-group>
            </div>
          </v-card-text>
        </v-card>
      </v-carousel-item>
    </v-carousel>
    <uploadPollDialog />
  </div>
</template>
<script>
import uploadPollDialog from "./UploadPollDialog.vue";
// import { isAuthenticated } from "@/common/commonFunctions.js";
import commonFunctions from "@/common/commonFunctions";
import apiUrl from "@/common/apiUrl";
// import apiUrl from "@/common/apiUrl";
import newAxios from "@/api/newAxios";
import { mapActions } from "vuex";
export default {
  name: "pollCard",
  data() {
    return {
      pollList: [],
      currentIndex: 0,
      userDetail: [],
    };
  },
  components: {
    uploadPollDialog,
  },
  created() {
    this.getPollList();
    this.getUserDetail();
  },
  watch: {
    selectedRadio() {
      this.postPollAnswer();
    },
  },
  methods: {
    ...mapActions({
      snackBar: "snackBar/showSnack",
    }),
    getUserDetail() {
      const onSuccess = (res) => {
        console.log(res, "kk");
        this.userDetail = res.data.user_detail;
      };
      const onFailure = () => {};
      let params = {};
      params["id"] = commonFunctions.getUserId();
      newAxios("get", apiUrl.ADMIN_PANEL_APIS, {
        params,
        onSuccess,
        onFailure,
        isTokenRequired: false,
      });
    },

    openPollDialog() {
      this.$store.commit("poll/togglePollModal", { show: true });
    },
    getPollList() {
      const onSuccess = (res) => {
        this.pollList = res.data.data;
        console.log(this.pollList);
      };
      const onFailure = () => {};
      newAxios("get", apiUrl.GET_POLL_LIST, {
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
    postPollAnswer(item, option) {
      const onSuccess = (res) => {
        this.snackBar({
          text: res.data.message,
          color: "success",
          timeout: 4500,
        });
        console.log(this.selectedRadio);
        this.getPollList();
      };
      const onFailure = () => {};
      let formData = {};
      formData["poll"] = item.id;
      formData["option"] = option.id;
      newAxios("post", apiUrl.POST_POLL_ANSWER, {
        data: formData,
        onSuccess,
        onFailure,
        isTokenRequired: true,
      });
    },
  },
};
</script>
<style scoped>
.qsn-text {
  font-family: Avenir;
  font-size: 16px;
  font-weight: 800;
  line-height: 26px;
  color: #333333;
}

.date-text {
  font-family: Avenir;
  font-size: 12px;
  font-weight: 500;
  line-height: 12px;
  color: grey;
}
.radios >>> .theme--light.v-messages {
  display: none;
}
</style>
